<template>
  <div style="display:flex;flex-direction: column; padding: 10px;background:white">
    <Modal
      v-model="successShow"
      :mask-closable="false"
      :closable="false"
      :footer-hide="true"
      width="360"
    >
      <div style="text-align:center">
        <img height="30" :src="getCategorySelection(get(pointsCategory, 'category')).icon" />
        <p>
          <b>Congratulations! You now have</b>
        </p>
        <p>
          <b>
            <span :style="{color: getCategorySelection(get(pointsCategory, 'category')).color}">{{myPoint}}</span>
            resiliency points
          </b>
        </p>
        <p>
          <b>in the {{get(pointsCategory, 'category')}} category.</b>
        </p>

        <div style="margin-top:20px">
          <div v-if="isCalculatingPoints">
            <p>
              <i class="fa fa-spinner fa-spin" /> Calculating Points..
            </p>
          </div>
          <div v-else>
            <div align="left" style="color:#aaa">
              <small>Accumulated points per module:</small>
            </div>
            <Card
              shadow
              v-for="(i,n) in accumulatedPoints"
              :key="n"
              :padding="5"
              style="background: #f1f1f1;margin-bottom:5px;"
            >
              <div
                align="left"
                class="truncate"
                style="font-weight:bolder;line-height: 18px;"
              >{{i.module.title}}</div>
              <div align="left" style="line-height: 18px;">
                <small>{{formatScore(i.points[get(pointsCategory, 'category')].toFixed(0))}} Points.</small>
              </div>
            </Card>
          </div>
        </div>

        <p align="right" style="margin-top:20px;">
          <Button
            size="small"
            style="border:none;width:100px"
            :style="{background: pointsCategory && getCategorySelection(get(pointsCategory, 'category')).color}"
            type="primary"
            @click="dismiss"
          >OK</Button>
        </p>
      </div>
    </Modal>

    <Modal
      v-model="contactUsShow"
      :mask-closable="false"
      :closable="false"
      :footer-hide="true"
      width="360"
    >
      <div>
        <p>
          <b>Contact Info</b>
        </p>

        <div style="height: 15px" />

        <div style="display: flex; flex-direction: row; align-items: center;">
          <Avatar icon="ios-telephone" size="large" style="margin: 0px 10px" />
          <div style="display: flex; width: 80%; flex-direction: column;">
            <div>
              <small>
                {{ contactInfo.contact_info_title }}
              </small>
            </div>            
            <div @click="onCallContactUs" class="pointer" style="display: flex;" >
              {{ contactInfo.contact_info }}
              &nbsp;
              <div style="width: 15px;" @click="copyToClipboard(contactInfo)">
                <i style="font-size:15px;vertical-align: middle" class="far fa-copy"></i>
              </div>
            </div>
            <!-- <div v-for="(contact, i) in brandContacts" :key="i" style="padding-bottom: 2px; border-bottom: 1.3px solid #ddd;">
              <b>{{contact.title}}</b>
              <div style="display: flex; align-items: center;">
                <p v-html="contact.data.tip"></p>
                <div @click="copyToClipboard(getTextFromHTML(contact.data.tip))" class="pointer">
                  <i style="font-size:15px; margin-left: 5px;" class="far fa-copy"></i>
                </div>
              </div>
            </div> -->
          </div>
        </div>

        <p align="right" style="margin-top:20px;">
          <Button type="primary" @click="dismissContactUs">OK</Button>
        </p>
      </div>
    </Modal>

    <i-button
      type="primary"
      @click="contactUs"
      ghost
      v-if="contactInfo.contact_info || contactInfo.contact_info_title"
      style="margin-bottom: 2px;"
    >
      <i class="fa fa-phone" />
      <span style="margin-left: 3px;">Contact Us</span>
    </i-button>
    <!-- <span style="text-align: center; margin-bottom: 20px;" @click="contactUs" v-if="contactInfo"> -->
    <!-- <p>
        CONTACT US :
        <a>{{ contactInfo }}</a>
    </p>-->
    <!-- </span> -->
    <!-- <Button type="primary" style="margin: 2px 0" v-if="contactInfo" @click="contactUs">Contact Us</Button> -->
    <Button type="primary" style="margin: 2px 0" v-if="surveyInfo" @click="openSurvey">Survey</Button>
    <!-- <Button type="primary" style="margin: 2px 0" @click="nextCourse" v-if="hasNextCourse">Next Course</Button> -->
    <Button
      type="primary"
      style="margin: 2px 0"
      v-if="!isFloating && !hasNextCourse"
      @click="finishCourse"
    >Finish Course</Button>
    <div class="navigation-control-container">
      <div class="previous">
        <span
          class="round-back rounded-border"
          @click="previousCourse"
          v-if="hasPreviousCourse"
        >Previous</span>
      </div>
      <div class="round-back">
        <span @click="doAction()">
          <Avatar class="action-back pointer" :src="require('@/assets/back.png')" />
        </span>
      </div>
      <div class="next">
        <span class="round-back rounded-border" @click="nextCourse" v-if="hasNextCourse">Next</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "iview";
import { mapGetters } from "vuex";
import Utils from "@/utils.js";
import VueCookie from "vue-cookie";
import _ from "lodash";
import copeImg from "@/assets/svg/cope.svg";
import thriveImg from "@/assets/svg/thrive.svg";
import nourishImg from "@/assets/svg/nourish.svg";
import healImg from "@/assets/svg/heal.svg";

export default {
  name: "ModuleBottomComponent",
  props: {
    surveyInfo: {
      type: String,
      required: false,
      default: ""
    },
    isFloating: {
      type: Boolean,
      required: false,
      default: false
    },
    moduleId: {
      type: String,
      required: true,
      default: ""
    },
    contactInfo: {
      type: Object,
      require: false,
      default: () => {
        return {
          contact_info: "",
          contact_info_title: ""
        }
      }
    }
  },
  data() {
    return {
      isCalculatingPoints: false,
      accumulatedPoints: null,
      successShow: false,
      contactUsShow: false,
      copeImg,
      thriveImg,
      nourishImg,
      healImg
    };
  },
  computed: {
    ...mapGetters("points", ["getCurrentUserResiliency"]),
    ...mapGetters("user", ["userInfo", "isAllowPoints", "brandContacts"]),
    get(){
      return _.get
    },
    pointsCategory() {
      let engageCourse = JSON.parse(
        VueCookie.get(
          `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`
        )
      );
      return engageCourse;
    },
    myPoint() {
      let tt = _.get(
        this.getCurrentUserResiliency,
        _.get(this.pointsCategory, "category", "Cope"),
        "Cope"
      );
      
      tt = tt || 0.00

      return this.formatScore(tt.toFixed(0));
    },
    isFloatingModule() {
      return this.$route.query.floating ? true : false;
    },
    moduleIds() {
      if (
        this.$route.query.careplan_ids &&
        this.$route.query.careplan_ids.split(",").length > 0
      )
        return this.$route.query.careplan_ids.split(",").map(e => e.trim());
      else return [];
    },
    hasNextCourse() {
      return this.moduleIds.indexOf(this.moduleId) < this.moduleIds.length - 1;
    },
    hasPreviousCourse() {
      return this.moduleIds.indexOf(this.moduleId) > 0;
    },
    roundButtonAlignment() {
      if (this.hasNextCourse && this.hasPreviousCourse) {
        return "center";
      } else if (this.hasNextCourse && !this.hasPreviousCourse) {
        return "end";
      } else if (this.hasPreviousCourse && !this.hasNextCourse) {
        return "end";
      } else {
        return "center";
      }
    },
    roundButtonWidth() {
      if (this.hasNextCourse && this.hasPreviousCourse) {
        return "50%";
      } else if (this.hasNextCourse && !this.hasPreviousCourse) {
        return "55%";
      } else if (this.hasPreviousCourse && !this.hasNextCourse) {
        return "50%";
      } else {
        return "100%";
      }
    },
    ...mapGetters("library", ["selectedTrackModules", "myTracks"])
  },
  methods: {
    getTextFromHTML(html) {
      let parsed = new DOMParser().parseFromString(html, "text/html")
      return parsed.children[0].innerText;
    },
    formatScore(score) {
      return score.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async getTrackAccumulatedPoints() {
      console.log("Load");
      try {
        this.isCalculatingPoints = false;
        this.accumulatedPoints = null;

        let track = this.track();
        let res = await this.$store.dispatch(
          "points/getCurrentUserTrackPointsFinish",
          {
            journalId: this.userInfo.journal_id,
            trackId: track.id
          }
        );

        this.accumulatedPoints = res;
        console.log(res);
      } catch (e) {
        console.log(e.response);
      } finally {
        this.isCalculatingPoints = false;
      }
    },
    checkpoint() {
      if (this.userInfo.user_type == "guest") {
        this.$store.commit("hitCheckpoint");
        return true;
      }
      return false;
    },
    getCategorySelection(v) {
      if (v == "Cope")
        return {
          icon: this.copeImg,
          color: "#1E89A7"
        };
      if (v == "Thrive")
        return {
          icon: this.thriveImg,
          color: "#F19B2F"
        };
      if (v == "Nourish")
        return {
          icon: this.nourishImg,
          color: "#83CA27"
        };
      if (v == "Heal")
        return {
          icon: this.healImg,
          color: "#4E1C9B"
        };

        
      return {};
    },
    dismiss() {
      try {
        var track = this.track();
        
        this.$router.push({
          path: "/track/" + track.id,
          query: {
            careplan_ids: track.data.modules.join(),
            title: track.title,
            category: this.$route.query.category
          }
        });
        this.successShow = false;
      } catch (error) {
        this.successShow = false;
      }
    },
    doAction() {
      if (!this.isFloatingModule) {
        let moduleRoute = JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_TRACK`
          )
        );
        this.$router.replace(moduleRoute);
        return false;
      }
      this.historyBack();
    },
    historyBack() {
      window.history.back();
    },
    modules() {
      var modules = [];
      this.myTracks.pages.forEach(track => {
        if (track.data.modules.includes(this.moduleId)) {
          modules = track.data.modules;
          return;
        }
      });
      return modules;
    },
    track() {
      var track = "";
      this.myTracks.pages.forEach(iTrack => {
        if (iTrack.data.modules.includes(this.moduleId)) {
          track = iTrack;
          return;
        }
      });
      return track;
    },
    contactUs() {
      this.$store.dispatch("statistics/postStats", {
        stat_type: "contact",
        stat_id: this.moduleId
      });

      if (!this.isFloatingModule) {
        let engageCourse = JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`
          )
        );
        this.$store.dispatch(
          "points/setUserActionPoints",
          {
            action: "view_contact",
            user_story_id: engageCourse.userStory,
            track_id: engageCourse.course,
            module_id: engageCourse.article,
            category: engageCourse.category
          },
          { root: 1 }
        );
      } else {
        this.$store.dispatch(
          "points/setUserActionPoints",
          {
            action: "view_contact",
            module_id: this.moduleId
          },
          { root: 1 }
        );
      }

      this.contactUsShow = true;

      // if (Utils.validateEmail(this.contactInfo)) {
      //   window.open("mailto:" + this.contactInfo);
      //   this.contactUsPointAction()
      // } else {
      //   if (this.$store.state.isMobile) {
      //     var dialerWindow = window.open("tel:" + this.contactInfo);
      //     dialerWindow.close();

      //     this.contactUsPointAction()
      //   } else {
      //     this.contactUsShow = true
      //     // this.$Message({
      //     //   closable: true,
      //     //   title: { content: "Contact Number" },
      //     //   icon: "ios-telephone",
      //     //   message: { content: this.contactInfo },
      //     //   buttons: [
      //     //     {
      //     //       label: "Ok",
      //     //       type: "primary",
      //     //       hideAfter: true,
      //     //       action: () => false
      //     //     }
      //     //   ]
      //     // });
      //   }
      // }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.$store.commit("showNotice", {
        type: "info",
        title: "Copy",
        desc: "Copied to clipboard"
      });
    },
    onCallContactUs() {
      this.copyToClipboard(this.contact_info)

      this.contactUsPointAction();
    },
    contactUsPointAction() {
      if (!this.isFloatingModule) {
        let engageCourse = JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`
          )
        );
        this.$store.dispatch(
          "points/setUserActionPoints",
          {
            action: "call_contact",
            user_story_id: engageCourse.userStory,
            track_id: engageCourse.course,
            module_id: engageCourse.article,
            category: engageCourse.category
          },
          { root: 1 }
        );
      } else {
        this.$store.dispatch(
          "points/setUserActionPoints",
          {
            action: "call_contact",
            module_id: this.moduleId
          },
          { root: 1 }
        );
      }
    },
    dismissContactUs() {
      this.contactUsShow = false;
    },
    openSurvey() {
      this.checkpoint();
      this.$emit("openSurveyIFrame");
    },
    async finishCourse() {
      this.checkpoint();
      this.getTrackAccumulatedPoints();

      if (this.isFloating) window.history.back();
      else {
        this.$store.dispatch("statistics/postStats", {
          stat_type: "finish_course",
          stat_id: this.moduleId
        });

        if (this.isAllowPoints) {
          let engageCourse = JSON.parse(
            VueCookie.get(
              `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`
            )
          );

          await this.$store.dispatch(
            "points/setUserActionPoints",
            {
              action: "finish_course",
              user_story_id: _.get(engageCourse, "userStory"),
              track_id: _.get(engageCourse, "course"),
              module_id: _.get(engageCourse, "article"),
              category: _.get(engageCourse, "category")
            },
            { root: 1 }
          );

          this.successShow = true;
        }
        else{
          this.$Message({
            title: { content: "Congratulations !" },
            message: { content: "You've finished the course" },
            buttons: [
              {
                label: "Ok",
                type: "primary",
                hideAfter: true,
                action: () => {
                  this.dismiss()
                }
              }
            ]
          });
        }
      }

      var finishedModulesList =
        JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}FINISHED_MODULES`
          )
        ) || [];

      var isModuleFinished = finishedModulesList.includes(this.moduleId);

      if (!isModuleFinished) finishedModulesList.push(this.moduleId);

      VueCookie.set(
        `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}FINISHED_MODULES`,
        JSON.stringify(finishedModulesList)
      );
    },
    previousCourse() {
      var previousModuleId = this.moduleIds[
        this.moduleIds.indexOf(this.moduleId) - 1
      ];

      this.$store
        .dispatch("library/getModuleElements", previousModuleId)
        .then(res => {
          console.log(res);
          VueCookie.delete(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_ELEMENTS`
          );
          VueCookie.delete(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_DOCUMENTS`
          );
          VueCookie.set(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_ELEMENTS`,
            JSON.stringify(res.elements.join())
          );
          VueCookie.set(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_DOCUMENTS`,
            JSON.stringify(res.documents.join())
          );
          this.$router.replace({
            path: "/module/" + previousModuleId + "?tab=course",
            query: {
              ...this.$route.query,
              tab: "course"
            }
          });
          this.$emit("previousCourse");
        });
    },
    nextCourse() {
      var nextModuleId = this.moduleIds[
        this.moduleIds.indexOf(this.moduleId) + 1
      ];

      let engageCourse = JSON.parse(
        VueCookie.get(
          `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`
        )
      );
      this.$store.dispatch(
        "points/setUserActionPoints",
        {
          action: "open_course",
          user_story_id: engageCourse.userStory,
          track_id: engageCourse.course,
          module_id: nextModuleId,
          category: engageCourse.category
        },
        { root: 1 }
      );

      this.$store
        .dispatch("library/getModuleElements", nextModuleId)
        .then(res => {
          console.log(res);
          VueCookie.delete(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_ELEMENTS`
          );
          VueCookie.delete(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_DOCUMENTS`
          );
          VueCookie.set(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_ELEMENTS`,
            JSON.stringify(res.elements ? res.elements.join() : "")
          );
          VueCookie.set(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_DOCUMENTS`,
            JSON.stringify(res.documents ? res.documents.join() : "")
          );

          this.$router.replace({
            path: "/module/" + nextModuleId + "?tab=course",
            query: {
              ...this.$route.query,
              tab: "course"
            }
          });
          this.$emit("nextCourse");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.round-back {
  margin: 10px;
  display: flex;
  justify-content: center;
  flex-grow: 1;
}
.rounded-border {
  border-color: var(--link-color);
  border: 1px solid;
  height: 36px;
  line-height: 32px;
  border-radius: 100px;
}
.next {
  color: var(--link-color);
  text-align: start;
  flex-grow: 2;
  min-width: 60px;
  min-height: 30px;
  span {
    cursor: pointer;
  }
}
.previous {
  color: var(--link-color);
  text-align: end;
  flex-grow: 2;
  min-width: 60px;
  min-height: 30px;
  span {
    cursor: pointer;
  }
}
.navigation-control-container {
  display: flex;
  align-items: center;
  text-align: center;
}
.action-back > img {
  margin-top: 0px !important;
  padding: 6px;
}

.action-back {
  border-style: solid;
  border-width: 1px;
  border-radius: 100px;
  width: 36px;
  height: 36px;
  border-color: var(--link-color);
}
</style>
